<template>
	<div class="relative flex items-center">
		<div class="flex h-5 items-center">
			<input
				:id="name"
				:aria-describedby="`${name}-description`"
				:name="name"
				type="checkbox"
				class="h-4 w-4 cursor-pointer rounded border border-gray-400 text-blue-400 checked:border-blue-400 focus:shadow-none focus:outline-none"
				:checked="isChecked"
				@change="onChange"
			/>
		</div>
		<label :for="name" class="cursor-pointer pl-3">
			<slot name="label">
				<span class="text-sm font-medium text-gray-700">
					{{ label }}
				</span>
			</slot>
		</label>
	</div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
	name: {
		type: String,
		default: 'sample',
		required: false,
	},
	label: {
		type: String,
		default: 'Sample',
		required: false,
	},
	checked: {
		type: Boolean,
		default: false,
		required: false,
	},
})

const emit = defineEmits(['change'])

const isChecked = computed(() => props.checked)

const onChange = (e) => {
	emit('change', e)
}
</script>
